// extracted by mini-css-extract-plugin
module.exports = {"text":"modal_text__28CdR","modal":"modal_modal__WA1nl","option":"modal_option__frU0i","spacio":"modal_spacio__111_K"};